"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.replace");
var _works = require("@/api/works/works");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      photoList: [],
      worksId: this.$route.query.worksId,
      worksInfo: {},
      infoList: [{
        label: "课程名称",
        value: "xx作品"
      }, {
        label: "所属组别",
        value: "高职组"
      }, {
        label: "课程名称",
        value: "xx作品"
      }, {
        label: "所属组别",
        value: "高职组"
      }, {
        label: "课程名称",
        value: "xx作品"
      }, {
        label: "所属组别",
        value: "高职组"
      }],
      entryList: [{
        label: "片段节选",
        type: "video",
        src: "",
        url: ""
      }, {
        label: "封面",
        type: "img",
        src: "",
        url: ""
      }, {
        label: "封面",
        type: "img",
        src: "",
        url: ""
      }]
    };
  },
  created: function created() {
    this.getWorksById();
  },
  filters: {
    getStatus: function getStatus(status) {
      if (status == 1) {
        return "待审核";
      }
      if (status == 2) {
        return "审核未通过";
      }
      if (status == 3) {
        return "待分配";
      }
      if (status == 4) {
        return "评审中";
      }
      if (status == 5) {
        return "结束";
      }
    }
  },
  methods: {
    // 获取快照列表
    getViewList: function getViewList(i) {
      var _this = this;
      this.photoList = [];
      (0, _works.getPhotoList)({
        url: i
      }).then(function (res) {
        var v = JSON.parse(res.data).imgs;
        var x = i.replace("file_doc", "file_gen_doc");
        v.forEach(function (item) {
          _this.photoList.push(x + "/" + item);
        });
      });
    },
    downLoadWorks: function downLoadWorks(e) {
      window.open(e);
    },
    download: function download(url, name) {
      if (url == null || url == "") {
        this.$message.error("暂无材料");
        return false;
      } else {
        var a = document.createElement('a');
        fetch(url).then(function (res) {
          return res.blob();
        }).then(function (blob) {
          a.href = URL.createObjectURL(blob);
          console.log(a.href);
          a.download = name; // 下载文件的名字
          document.body.appendChild(a);
          a.click();
        });
      }
    },
    getWorksById: function getWorksById() {
      var _this2 = this;
      (0, _works.getWorksById)({
        id: this.worksId
      }).then(function (res) {
        _this2.worksInfo = res.data;
      });
    }
  }
};